import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import useAgencyOrderBundles from '@hooks/useAgencyOrderBundles'

import AgencyOrderBundleListItem from './AgencyOrderBundleListItem'

const OrderBundles = (props: { agencyId: number }) => {
  const { agencyId } = props

  const orderBundlesPayload = useAgencyOrderBundles({
    filters: { agency_id: agencyId },
    requestOptions: { include_agency_order_bundle_order_bundle: true },
    performHttpRequests: !!agencyId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredAgencyOrderBundles,
    filteredAgencyOrderBundlesCount,
    hasFilteredAgencyOrderBundles,
    loading,
  } = orderBundlesPayload

  return (
    <DashboardModule title="Bundles" loading={loading}>
      <Box flexDirection="column">
        {!loading && !hasFilteredAgencyOrderBundles && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Bundles present
            </DashboardModule.BlankState.Title>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredAgencyOrderBundles && (
          // @ts-expect-error TS2322
          <DashboardModule.ScrollableSection flexDirection="column">
            {filteredAgencyOrderBundles.map(agencyOrderBundle => (
              <AgencyOrderBundleListItem
                key={agencyOrderBundle.id}
                agencyOrderBundle={agencyOrderBundle}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredAgencyOrderBundlesCount}
          loading={loading}
        />
      </Box>
    </DashboardModule>
  )
}

export default OrderBundles
